import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../ChartTableToggle";
import GnaStatisticsVolumeAnylysis from "./GnaStatisticsVolume";
import GnaStatisticsCostAnylysis from "./GnaStatisticsCost";
// import DailyAnalysis from "./DailyUtilisation/DailyAnalysis";
// import MonthAnalysis from "./DailyUtilisation/MonthAnalysis";
import { fetchOptimizerStatistics } from "../../../Utility/RestApi";
const DataTabs = ["Volume", "Cost"];

export default function GnaTgnaStatisticsAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  activeTab
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  activeTab?:string
}) {
  // const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    // if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const res = await fetchOptimizerStatistics();
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="py-5 px-2">
        {/* <div className="flex justify-between items-center mb-3">
          <h2 className="chartHeading w-60">Scenario Statistics</h2>
          <div className="flex items-center gap-3">
            <ToggleTabs
              tabs={DataTabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </div> */}
        {activeTab === "Volume" && (
          <GnaStatisticsVolumeAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading}
            data={data}
          />
        )}
        {activeTab === "Cost" && (
          <GnaStatisticsCostAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading}
            data={data}
          />
        )}
      </div>
    </>
  );
}
